// SPDX-License-Identifier: Elastic-2.0
/**
 * NotFoundPage (T-004) — terminal route for unknown URLs.
 *
 * Kept intentionally minimal at v0.1; a polished 404 (with link back to
 * `/dashboard`, localized copy, Mirlai mark) can be designed later. The
 * job today is just to give the router a destination for `*` so we never
 * blank-screen on a bad URL.
 */
import { Link } from "react-router-dom";
import { ROUTES } from "../routing/routes";

export function NotFoundPage(): JSX.Element {
  return (
    <div data-testid="not-found-page" style={{ padding: "2rem", textAlign: "center" }}>
      <h1 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 500 }}>404</h1>
      <p style={{ marginTop: "0.5rem", color: "rgba(38,38,38,0.65)" }}>
        Page not found.
      </p>
      <p style={{ marginTop: "1rem" }}>
        <Link to={ROUTES.DASHBOARD}>Back to dashboard</Link>
      </p>
    </div>
  );
}
